/* @flow */
/*jshint esversion: 6 */
import { Button, Card, Col, Form, Icon, InputNumber, message, Popconfirm, Radio, Row, Modal } from "antd";
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericSelector from "../../components/GenericSelector";
import TableIDs from "../../data/TableIDs";
import { Job, User, OutputType, ProcessType } from '../../JmReact';
import TableLineIcons from "../../components/TableLineIcons";
import ResponsiveTable from "../../components/ResponsiveTable";
import SelectorItemClassic from "../../components/SelectorItemClassic";
import moment from "moment";
import GenericSelectorItemTags from "../../components/GenericSelectorItemTags";
import GenericTable from "../../components/GenericTable";

class CreateDoc15ForAutoIphone extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false,
            modalOpenEditDoc: false,

            _number: null,
            _pos: null,
            _supplier: null,
            _supplierName: null,
            _storage: null,
            _storageName: null,

            _addItemCode: null,
            _addItemName: null,
            _addItemQty: null,
            _addItemQtyInMonth: null,

            _itemsList: [],

            _suppOnly: "1",

            branchMessage: null,
            supplierMessage: null,
        }

        this.id = "temporaryDocuments";
        this.id_TagItems = "TAG_ITEMS_TO_ORDER";

        this.selectors = [
            { id: TableIDs.genericSelectorSuppliers, api: "get_suppliers" },
            { id: TableIDs.genericSelectorStorages, api: "get_storage_list" },
        ];

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData }
        this.selectors.forEach(x => { if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector } })

        this.api = {
            get: "get_documents_for_user",
            get_draft: "create_temp_doc_type",
            save_draft: "save_temp_doc_short",
            save_draft_lines: "save_temp_doc_lines_short",
            save_temp_doc: "save_temp_document",
            delete_draft: "delete_temp_document",
            get_qty_month: "get_item_qty_in_month_order_supp",

            get_tag_items: "get_items_by_tag_to_order",
        }

        this.itemCodeChange = null;

        this.isCreateNewDraft = false;
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    componentDidMount() {
        this.apiTempList()
    }

    apiTempList = () => {
        this.props.dataActions.genericDataSetFilter(this.id, this.props.user.companyCode, this.props.user.token, { docTypeId: 15 }, this.api.get)
    }

    refreshData = (docNum) => {
        if (!this.isCreateNewDraft) {
            this.isCreateNewDraft = true;
            this.sendAPI(this.api.get_draft, "_docNum\f_docType\r" + (docNum ? docNum : "") + "\f15", (ob) => {
                let _number = null;
                let _pos = null;
                let _supplier = null;
                let _storage = null;

                let _itemsList = ob.data ?
                    ob.data.split("\r").map((x, i) => {
                        let y = x.split("\f");
                        if (!i) {
                            _number = y[0];
                            _pos = y[1];
                            _storage = y[2];
                            _supplier = y[3];
                        }
                        return {
                            key: i + 1,
                            index: i,
                            lineNumber: i + 1,
                            itemCode: y[4],
                            itemDesc: y[5],
                            itemQty: y[6],
                            itemQtyInMonth: y[7],
                        }
                    }).filter(f => f.itemCode)
                    : []
                this.setState({
                    _number, _pos, _supplier, _storage, _itemsList,
                    modalOpenEditDoc: true,
                    _addItemCode: null,
                    _addItemName: null,
                    _addItemQty: null,
                    _addItemQtyInMonth: null,
                }, () => {
                    this.isCreateNewDraft = false;
                    this.checkSupplierBranchDelivery()
                })
            })
        }
    }

    addItem = () => {
        const { _itemsList, _addItemCode, _addItemName, _addItemQty, _addItemQtyInMonth } = this.state;
        this.setState({
            _itemsList: [
                ..._itemsList,
                {
                    key: _itemsList.length + 1,
                    index: _itemsList.length,
                    lineNumber: _itemsList.length + 1,
                    itemCode: _addItemCode,
                    itemDesc: _addItemName,
                    itemQty: _addItemQty,
                    itemQtyInMonth: _addItemQtyInMonth,
                }
            ],
            _addItemCode: null,
            _addItemName: null,
            _addItemQty: null,
            _addItemQtyInMonth: null,
        }, () => {
            this.saveDraft(this.state)
            document.getElementById("search_item_input_id").focus()
        })
    }

    checkSupplierBranchDelivery = () => {

        const { _supplier, _storage } = this.state;
        if (_supplier && _storage) {
            this.sendAPI("check_supplier_branch_delivery", { _supplier, _storage }, (ob) => {
                if (ob.data) {
                    const [_resCode1, _resCode2, _resMessage1, _resMessage2, _orderRegDate] = ob.data.split("\f");
                    this.setState({ branchMessage: _resMessage2, supplierMessage: _resMessage1 })
                }
            })
        }
    }

    getModalContent = () => {
        const mobile = window.innerWidth <= 600;
        const suppDataset = this.props.data[TableIDs.genericSelectorSuppliers] ? this.props.data[TableIDs.genericSelectorSuppliers].dataset : []
        const draftList = this.props.data[this.id].data;
        const render = t => t
        const renderNum = t => t ? Math.round(t * 100) / 100 : ""
        const onChangeSelector = () => {
            this.saveDraft(this.state)
            setTimeout(() => {
                this.refreshData(this.state._number)
                document.getElementById("search_item_input_id").focus()
            }, 1000);
            this.checkSupplierBranchDelivery()
        }
        if (this.state.modalOpenEditDoc) {
            const onChangeItem = () => {
                this.sendAPI(this.api.get_qty_month, "_item\r" + this.state._addItemCode, (ob) => {
                    this.setState({ _addItemQty: 1, _addItemQtyInMonth: renderNum(ob.data) }, () => {
                        let item_qty_input = document.getElementById("item_qty_input");
                        if (item_qty_input) {
                            item_qty_input.focus();
                            setTimeout(() => { item_qty_input.select() }, 1000)
                        }
                    })
                })
            }
            return (<div>
                <Row>
                    <Col span={6} style={{ height: 60 }}>{this.getText(18748)}</Col>
                    <Col span={18} style={{ height: 60 }}>
                        <GenericSelector
                            {...this.props}
                            {...this.selectors[1]}
                            value={this.state._storage}
                            onChangeGetDetailed={({ code, name }) => {
                                this.setState({ _storage: code, _storageName: name }, onChangeSelector)
                            }}
                            onChange={() => { }}
                        />
                    </Col>
                    <Col span={6} style={{ height: 60 }}>{this.getText(18747)}</Col>
                    <Col span={18} style={{ height: 60 }}>
                        <GenericSelector
                            {...this.props}
                            {...this.selectors[0]}
                            value={this.state._supplier}
                            onChangeGetDetailed={({ code, name }) => {
                                this.setState({ _supplier: code, _supplierName: name }, onChangeSelector)
                            }}
                            onChange={() => { }}
                        />
                    </Col>
                    {this.state.supplierMessage && <div style={{ color: 'red', marginTop: 15 }}>{this.state.supplierMessage}</div>}
                    {this.state.branchMessage && <div style={{ color: 'red', marginTop: 15 }}>{this.state.branchMessage}</div>}
                    <Col span={6} style={{ marginTop: 15 }}>{this.getText(22828)}</Col>
                    <Col span={18} style={{ marginTop: 15 }}>
                        <GenericSelectorItemTags
                            {...this.props}
                            value={this.state._addItemFromTag}
                            onChange={e => { this.setState({ _addItemFromTag: e }) }}
                            disabled={!this.state._supplier || !this.state._storage}
                        />
                    </Col>
                    <Col span={24}>
                        <Button
                            style={{ margin: 15 }}
                            onClick={() => { this.setState({ modalTagItems: true }) }}
                            disabled={!this.state._addItemFromTag}
                        >{this.getText(22829)}</Button>
                        <Button
                            style={{ margin: 15 }}
                            onClick={() => { this.setState({ _addItemFromTag: null }) }}
                            disabled={!this.state._addItemFromTag}
                        >{this.getText(22830)}</Button>
                    </Col>
                    <Col span={6} style={{ marginTop: 15 }}>{this.getText(18762)}</Col>
                    <Col span={18} style={{ marginTop: 15 }}>
                        <SelectorItemClassic
                            {...this.props}
                            id={"item_code_input"}
                            valueId={this.state._addItemCode} valueName={this.state._addItemName}
                            onChange={(code, name) => {
                                this.setState({ _addItemCode: code, _addItemName: name }, () => {
                                    clearTimeout(this.itemCodeChange);
                                    this.itemCodeChange = setTimeout(onChangeItem, 1000);
                                })
                            }}
                            onBlur={onChangeItem}
                            disabled={!this.state._supplier || !this.state._storage}
                            isPerSupplier={this.state._suppOnly == "1" ? suppDataset.find(f => f.code == this.state._supplier) : null}
                        />
                    </Col>
                    <Col span={24}>
                        <Radio.Group value={this.state._suppOnly} onChange={e => { this.setState({ _suppOnly: e.target.value }) }}>
                            <Radio value="0">{this.getText(18787)}</Radio>
                            <Radio value="1">{this.getText(18788)}</Radio>
                        </Radio.Group>

                        <br />
                        {this.getText(18763)}
                        <InputNumber id="item_qty_input" style={{ margin: 15 }} value={this.state._addItemQty} onChange={e => { this.setState({ _addItemQty: e }) }} />
                        <Button
                            style={{ margin: 15 }}
                            onClick={this.addItem}
                            disabled={!this.state._addItemCode || !this.state._addItemQty || !this.state._supplier || !this.state._storage}
                        >{this.getText(18764)}</Button>
                    </Col>
                </Row>



                <ResponsiveTable
                    tableOnly
                    dataSource={this.state._itemsList}
                    columns={[
                        { title: this.getText(18757), key: "itemCode", dataIndex: "itemCode", width: "20%", render },
                        { title: this.getText(18758), key: "itemDesc", dataIndex: "itemDesc", width: "30%", render },
                        { title: this.getText(18759), key: "itemQty", dataIndex: "itemQty", width: "15%", render: renderNum },
                        { title: this.getText(18760), key: "itemQtyInMonth", dataIndex: "itemQtyInMonth", width: "25%", render: renderNum },
                        {
                            title: "", key: "lineNumber", dataIndex: "lineNumber", width: "10%", render: t => {
                                return (<TableLineIcons
                                    onDelete={() => { this.setState({ _itemsList: this.state._itemsList.filter(f => f.lineNumber != t) }) }}
                                    deleteQuetion={{ title: this.getText(18761), okText: this.getText(18753), cancelText: this.getText(18754) }}
                                />)
                            }
                        },
                    ]}
                />
            </div>)
        } else {
            return (<div>
                {draftList.map(x => {
                    let y = x.split("\f");
                    return (<Card title={"הזמנה מספק " + y[0]} style={{ margin: 10 }}>
                        <p>{y[4]} - {y[5]}</p>
                        <p>{y[3]}</p>
                        <TableLineIcons
                            onEdit={() => { this.refreshData(y[0]) }}
                            onDelete={() => {
                                this.sendAPI(this.api.delete_draft, "number\r" + y[0], () => {
                                    message.success(this.getText(18755))
                                    this.apiTempList()
                                })
                            }}
                            deleteQuetion={{ title: this.getText(18752), okText: this.getText(18753), cancelText: this.getText(18754) }}
                        />
                    </Card>)
                })}
            </div>)
        }
    }

    getModalFooter = () => {
        if (this.state.modalOpenEditDoc) {
            return [
                <Button type="primary" onClick={this.saveTempDoc} disabled={!this.state._itemsList.length}>{this.getText(18749)}</Button>,
                <Popconfirm
                    onConfirm={() => { this.setState({ _itemsList: [] }, () => { this.saveDraft(this.state) }) }}
                    title={this.getText(18765)} okText={this.getText(18753)} cancelText={this.getText(18754)} >
                    <Button>{this.getText(18750)}</Button>
                </Popconfirm>,
                <Button onClick={this.onCancel}>{this.getText(18751)}</Button>,
            ]
        } else {
            return [
                <Button type="primary" onClick={() => { this.refreshData() }}>{this.getText(18756)}</Button>
            ]
        }
    }

    onCancel = () => {
        const draft = { ...this.state }
        this.setState({
            modalOpen: false,
            modalOpenEditDoc: false,
            _number: null,
            _pos: null,
            _supplier: null,
            _supplierName: null,
            _storage: null,
            _storageName: null,
            _itemsList: [],
            _addItemCode: null,
            _addItemName: null,
            _addItemQty: null,
            _addItemQtyInMonth: null,
        }, () => {
            this.saveDraft(draft)
        })
    }

    saveDraft = (draft) => {
        const { _number, _pos, _storage, _supplier, _itemsList } = draft;
        let dataSend1 = "_supplier\f_storage\f_number\f_type\f_pos\r"
            + _supplier + "\f" + _storage + "\f" + _number + "\f15\f" + _pos;
        let dataSend2 = "lineNumber\fitemCode\fitemQty\f_number\f_type\f_pos\r"
            + _itemsList.map(x => x.lineNumber + "\f" + x.itemCode + "\f" + x.itemQty + "\f" + _number + "\f15\f" + _pos).join("\r")

        this.sendAPI(this.api.save_draft, dataSend1, () => {
            this.sendAPI(this.api.save_draft_lines, dataSend2, this.apiTempList)
        })
    }

    sendToSupplier = ({ _pos, _supplier }) => {

        this.sendAPI("get_last_doc_number_by_type", "_pos\f_docType\r" + _pos + "\f15", (ob1) => {
            this.sendAPI("get_print_data_new_doc", "custID\fdocType\fdocPos\r" + _supplier + "\f15\f" + _pos, (ob2) => {
                const lastDocumentNumber = ob1.data ? ob1.data.split("\f")[0] : null;
                const [defaultPrintType, targetMobile, targetEmail] = ob2.data ? ob2.data.split("\f") : [];
                const target = targetEmail ? targetEmail : targetMobile ? targetMobile : null;
                const targetType = targetEmail ? '3' : targetMobile ? '2' : null;
                if (lastDocumentNumber && target && targetType) {
                    let params = {
                        DocumentNumber: lastDocumentNumber,
                        DocumentTypeID: 15,
                        DocumentPOSID: _pos,
                        CompanyCode: this.props.user.companyCode,
                        userID: this.props.user.userId,
                        userName: encodeURIComponent(this.props.user.displayName),
                        isOriginal: true,
                        isDraft: false,
                        CentralFatherItem: '0',
                        PrintFormat: "0",
                        reportName: "reports/DocumentCopy.pdf",
                    }
                    let user = new User(this.props.user.token, this.props.user.companyCode);
                    let job = new Job(user, 'send_report', OutputType.OUTPUT_TYPE_BLOB, ProcessType.PROCESS_TYPE_SYNC);
                    let metaData = 'targetType\freportName\ftargetSystem\fcustomerId\ftarget\freportFormat\fisDoc\r' + targetType + '\fDocumentCopy\f0\f0\f' + target + '\f0\f1';
                    let paramsKeys = Object.keys(params);
                    let paramsData = paramsKeys.join("\f") + "\r" + paramsKeys.map(x => params[x] ? params[x] : "").join("\f")
                    job.setSection('META', metaData);
                    job.setSection('PARAMS', paramsData);
                    job.send("/cgi-bin/CashOnTab", () => {
                        message.success(this.getText(17755))
                    }, (e) => { console.error(e) });
                }
            })
        })
    }


    saveTempDoc = () => {
        Modal.confirm({
            content: (<>
                <h2>{this.getText(22841)}</h2>
                <h2>{this.state._supplierName}</h2>
                <h2>{this.state._itemsList.length} {this.getText(22842)}, {this.state._itemsList.reduce((acc, curr) => acc + parseFloat(curr.itemQty), 0).toFixed(2)} {this.getText(22843)}</h2>
            </>),
            okText: this.getText(22844),
            cancelText: this.getText(22845),
            onOk: () => {
                const { _number, _pos, _supplier } = this.state;
                this.sendAPI(this.api.save_temp_doc, "DocNum\fDocTypeID\fDocPosID\fisDeleteDraft\r" + _number + "\f15\f" + _pos + "\f1", () => {
                    this.sendToSupplier({_pos, _supplier })
                    message.success(this.getText(18768));
                    this.onCancel()
                    this.apiTempList()
                })
            }
        })

    }

    getAddItemFromTagQty = (value, record) => {
        const { editing, editedRecord } = this.props.data[this.id_TagItems]
        return editing == record.key ?
            (<InputNumber
                value={editedRecord.ItemQty}
                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id_TagItems, { ItemQty: e }) }}
            />)
            : value;
    }

    getAddItemFromTagIcons = (t, record) => {
        const { editing, editedRecord, data } = this.props.data[this.id_TagItems]
        const onSaveRow = (value) => {
            this.props.dataActions.setJson(this.id_TagItems, {
                data: data.map((x, i) => {
                    if (i == record.index) {
                        let y = x.split("\f");
                        y[2] = value;
                        return y.join("\f");
                    } else {
                        return x
                    }
                }),
                editing: -1,
                editedRecord: {},
            })
        }
        return editing == record.key ?
            (<TableLineIcons
                onCheck={() => { onSaveRow(editedRecord.ItemQty) }}
                onClose={() => { this.props.dataActions.genericDataCancelEditing(this.id_TagItems) }}
            />)
            : (<TableLineIcons
                onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id_TagItems, record.key, record.index) }}
                genericIcons={[{ type: "copy", tooltip: this.getText(22839), onClick: () => { onSaveRow(record.LimitMinimum) } }]}
            />)
    }

    addItemFromTagToOrder = () => {
        let oldItemsList = [...this.state._itemsList];
        let listLength = oldItemsList.length;
        this.setState({
            _itemsList: [
                ...oldItemsList,
                ...this.props.data[this.id_TagItems].data.map((x, i) => {
                    let y = x.split("\f");
                    return {
                        key: listLength + i + 1,
                        index: listLength + i,
                        lineNumber: listLength + i + 1,
                        itemCode: y[0],
                        itemDesc: y[1],
                        itemQty: y[2],
                        itemQtyInMonth: y[4],
                    }
                }).filter(f => f.itemQty > 0)
            ],
            _addItemFromTag: null,
            modalTagItems: false,
        }, () => {
            this.saveDraft(this.state)
        })
    }


    render() {
        const draftList = this.props.data[this.id].data;
        return (<div style={{ textAlign: "center", marginBottom: 5, display: 'inline-block', verticalAlign: 'text-top' }}>
            <Button onClick={() => { this.setState({ modalOpen: true }, () => { if (!draftList.length) this.refreshData() }) }}>
                <Icon type={"project"} style={{ marginLeft: 5 }} />
                {this.getText(18746)}
            </Button>
            <GenericModal
                visible={this.state.modalOpen}
                onCancel={this.onCancel}
                title={this.getText(18746)}
                footer={this.getModalFooter()}>
                {this.getModalContent()}
                <GenericModal
                    visible={this.state.modalTagItems}
                    onCancel={() => { this.setState({ modalTagItems: false }) }}
                    title={this.getText(22831)}
                    footer={[
                        <Button onClick={() => { this.setState({ modalTagItems: false }) }}>{this.getText(22833)}</Button>,
                        <Button
                            type="primary"
                            disabled={!this.props.data[this.id_TagItems]?.data?.map((x, i) => x.split("\f")[2])?.filter(f => f)?.length}
                            onClick={this.addItemFromTagToOrder}
                        >{this.getText(22832)}</Button>,
                    ]}>
                    {this.props.data[this.id_TagItems]?.count > 200 && <div style={{ color: 'red', marginBottom: 10 }}>{this.getText(22840)}</div>}
                    {this.state.modalTagItems && (<GenericTable
                        {...this.props}
                        tableOnly
                        id={this.id_TagItems}
                        getApi={this.api.get_tag_items}
                        columns={[
                            { title: this.getText(22834), key: "ItemCode", dataIndex: "ItemCode", width: "20%", render: t => t },
                            { title: this.getText(22835), key: "ItemName", dataIndex: "ItemName", width: "20%", render: t => t },
                            { title: this.getText(22836), key: "LimitMinimum", dataIndex: "LimitMinimum", width: "20%", render: t => t },
                            { title: this.getText(22837), key: "ItemQty", dataIndex: "ItemQty", width: "20%", render: this.getAddItemFromTagQty },
                            { title: this.getText(22838), width: "20%", render: this.getAddItemFromTagIcons }
                        ]}
                        filters={{
                            _tag: this.state._addItemFromTag,
                            _supplier: this.state._supplier,
                            _storage: this.state._storage,
                        }}
                        scrool={{ y: window.innerHeight - 400 }}
                        pagination={false}
                    />)}
                </GenericModal>
            </GenericModal>
        </div>)
    }
}

export default CreateDoc15ForAutoIphone;